// Maps a URL path prefix to the module's spec doc path. Used by the module-
// context doc overlay to open the right doc without hard-coding paths inside
// each module screen. Longest-prefix wins so "/consultants/foo" resolves to
// the consultants module doc.

const RULES: { prefix: string; doc: string }[] = [
  { prefix: "/consultants",   doc: "spec/modules/consultants.md" },
  { prefix: "/customers",     doc: "spec/modules/customers.md" },
  { prefix: "/matrix",        doc: "spec/modules/admin-matrix.md" },
  { prefix: "/vacancies/new", doc: "spec/modules/vacancies.md" },
  { prefix: "/vacancies",     doc: "spec/modules/vacancies.md" },
  { prefix: "/workflows",     doc: "spec/modules/workflows.md" },
  { prefix: "/consolidation", doc: "spec/modules/consolidation.md" },
  { prefix: "/stack",         doc: "spec/modules/stack.md" },
  { prefix: "/settings",      doc: "spec/modules/settings.md" },
  { prefix: "/profile",       doc: "spec/modules/consultants.md" },
  // /docs is the docs viewer itself — no button there.
];

export function docPathForPath(pathname: string): string | null {
  if (pathname === "/") return "spec/modules/dashboard.md";
  const match = RULES
    .filter((r) => pathname === r.prefix || pathname.startsWith(r.prefix + "/"))
    .sort((a, b) => b.prefix.length - a.prefix.length)[0];
  return match?.doc ?? null;
}
